import React, { useEffect, useState } from 'react';
import styles from './Faqs.module.scss';
import { Row, Col } from 'reactstrap';
import { Collapse } from 'antd';
import './OverRide.scss';
import { Animated } from 'react-animated-css';
import { PlusOutlined } from '@ant-design/icons';
import { MinusOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const Faqs = () => {
  let [keyCheckerState, setKeyCheckerState] = useState();

  const genExtra = () => (
    <PlusOutlined
      onClick={event => {
        // If you don't want click extra trigger collapse, you can prevent this:
        event.stopPropagation();
      }}
    />
  );
  const genExtra2 = () => (
    <MinusOutlined
      onClick={event => {
        // If you don't want click extra trigger collapse, you can prevent this:
        event.stopPropagation();
      }}
    />
  );
  function callback(key) {
    if (key[1]) {
      key.shift();
      setKeyCheckerState(key[0]);
    } else {
      setKeyCheckerState(key[0]);
    }
  }
  const text1 = `
               Mutant Ape Base Club is an NFT project that features 
               unique and collectible Mutant Ape-themed digital assets. 
               These NFTs represent ownership of digital artwork and may 
               come with additional perks or benefits within the Mutant Ape Base Club ecosystem.
`;

  const text2 = `
               To purchase Mutant Ape Base Club NFTs, you can visit the official Mutant Ape Base Club 
               website or marketplace. There, you will find available NFTs for sale. 
               Follow the instructions provided to complete the purchase using the specified cryptocurrency.
`;

  const text3 = `
               Yes, Mutant Ape NFTs are typically tradable and can be resold on listed NFT marketplaces.
               You can list your Mutant Ape NFTs for sale or trade them with other collectors. 
               Ensure you follow the guidelines and requirements of the specific marketplace where you wish to transact.
`;

  const text4 = `
               Mutant Ape NFT holders will receive exclusive benefits or privileges within
               the Mutant Ape Base Club ecosystem. These benefits can vary and may include
               access to exclusive events, airdrops, virtual experiences, governance participation, 
               or early access to new releases. The specific benefits associated with each NFT will be outlined in the project's documentation.
`;

const text5 = `
              To participate in the governance of Mutant Ape Base Club, token holders 
              have voting rights or the ability to propose and discuss changes to the ecosystem. 
              Token holders can participate in voting on proposals, contribute to community discussions, 
              or even become community representatives. Detailed information on governance participation 
              will be provided by the project team through official channels.
`;

const text6 = `
              The native token of Mutant Ape Base Club is [$MAY]. It serves various purposes 
              within the ecosystem, such as governance participation, accessing exclusive features, 
              or earning rewards. The tokenomics, utility, and distribution of the native token will 
              be detailed in the project's official documentation.
`;

const text7 = `
              To stay updated with the Mutant Ape Base Club project, you can follow our official website, 
              social media accounts, and join our official community channels. Regularly check for announcements, 
              news, and project updates to ensure you have the most up-to-date information.
`;

  return (
    <div className={styles.main_faqs} id='faqss'>
      <Animated
        isVisible={true}
        animationIn='animate__fadeInUp'
        animationOut='animate__fadeInUp'
      >
        <Row>
          <Col sm={12} md={12}>
            <div className={styles.faqs_head}>
              <h1>FAQ</h1>
            </div>
          </Col>
          <Col sm={12} md={12} id='faqs'>
            <Collapse
              defaultActiveKey={[]}
              onChange={callback}
              expandIconPosition='right'
            >
              <Panel
                header='What is Mutant Ape Base Club?'
                key='1'
                extra={keyCheckerState === '1' ? genExtra2() : genExtra()}
              >
                <p>{text1}</p>
              </Panel>
              <Panel
                header='How can I purchase Mutant Ape NFTs?'
                key='2'
                extra={keyCheckerState === '2' ? genExtra2() : genExtra()}
              >
                <p>{text2}</p>
              </Panel>
              <Panel
                header='Can I resell or trade my Mutant Ape NFTs?'
                key='3'
                extra={keyCheckerState === '3' ? genExtra2() : genExtra()}
              >
                <p>{text3}</p>
              </Panel>
              <Panel
                header='What benefits do Mutant Ape NFT holders receive?'
                key='4'
                extra={keyCheckerState === '4' ? genExtra2() : genExtra()}
              >
                <p>{text4}</p>
              </Panel>
              <Panel
                header='How can I participate in the governance of Mutant Ape Base Club?'
                key='5'
                extra={keyCheckerState === '5' ? genExtra2() : genExtra()}
              >
                <p>{text5}</p>
              </Panel>
              <Panel
                header='What is the native token of Mutant Ape Base Club?'
                key='6'
                extra={keyCheckerState === '6' ? genExtra2() : genExtra()}
              >
                <p>{text6}</p>
              </Panel>
              <Panel
                header='How can I stay updated with the Mutant Ape Base Club project?'
                key='7'
                extra={keyCheckerState === '7' ? genExtra2() : genExtra()}
              >
                <p>{text7}</p>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      </Animated>
    </div>
  );
};

export default Faqs;
